import { createFileRoute } from "@tanstack/react-router";

import { FinancingSolarLeasePlanPage } from "@/components/financing/financing-solar-lease-plan-page";
import {
  SOLAR_LEASE_FAQS,
  SOLAR_LEASE_PLAN_META,
} from "@/content/financing-solar-lease-plan";

const { title: TITLE, description: DESCRIPTION } = SOLAR_LEASE_PLAN_META;

export const Route = createFileRoute("/financing-solar-lease-plan")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: SOLAR_LEASE_FAQS.filter((f) => f.a).map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
    ],
  }),
  component: FinancingSolarLeasePlanPage,
});
